import { useTranslation } from 'react-i18next';

import { positionExport, type PositionStatusFilter } from '@/api/domains/organization/positions';
import { useExport } from '@/hooks/ui/useExport';


export interface UsePositionExportParams {
  searchText?: string;
  status?: PositionStatusFilter;
  areaId?: number;
}

interface UsePositionExportResult {
  exportPositions: () => Promise<void>;
  isExporting: boolean;
}

export function usePositionExport(params: UsePositionExportParams): UsePositionExportResult {
  const { t: translate } = useTranslation();

  const { onExport: exportPositions, isExporting } = useExport({
    exportFn: () => positionExport.export({
      searchText: params.searchText,
      status: params.status,
      areaId: params.areaId,
    }),
    successMessage: translate('organization:messages.positionsExportSuccess'),
    errorMessage: translate('organization:messages.positionsExportError'),
  });

  return { exportPositions, isExporting };
}

export default usePositionExport;
